import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnInit
} from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { DeliveryType } from 'src/app/models';

@Component({
  selector: 'pos-order-type-radio-group',
  templateUrl: './order-type-radio-group.component.html',
  styleUrls: ['./order-type-radio-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderTypeRadioGroupComponent
  implements OnInit, ControlValueAccessor, AfterViewInit
{
  DELIVER_TYPE_OPTIONS = [
    {
      id: DeliveryType.PICK_UP,
      name: 'deliveryType.pickup'
    },
    {
      id: DeliveryType.DELIVERY,
      name: 'deliveryType.delivery'
    }
  ];

  value!: string;

  // used to display error
  public formControl = new FormControl('');

  constructor(public ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  ngOnInit() {}

  public ngAfterViewInit(): void {
    // syncing with validators on host element
    this.formControl = this.ngControl.control as FormControl;
  }

  public onInputSelected(value: string) {
    this.value = value;
    this.onChange(this.value);
    this.onTouched();
  }

  public onBlur() {
    this.onTouched();
  }

  public writeValue(value: string) {
    this.value = value;
  }

  public registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  public registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  private onTouched = () => {};
  touched = false;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onChange = (_value: string) => {};
}
